module.exports = function (title, obj) {
  var t = "Reformation in ".concat(title);
  if (obj.counter_reformation) {
    t = "Counter-Reformation in ".concat(title);
  }
  var html = "\n      <div class=\"reformation-overlay\" id=\"reformation-overlay\">\n        <div class=\"title\">".concat(t, "</div>\n\t<div class=\"reformation-box\">\n\t  <div class=\"protestant\">\n\t    <div class=\"title\">Protestants</div>\n\t  </div>\n\t  <div class=\"papacy\">\t    \n            <div class=\"title\">Papacy</div>\n            </div>\n          </div>\n        </div>\n      </div>\n  ");
  return html;
};